import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { useAdmin } from "@/admin/AdminContext";
import { AdminFrame } from "@/admin/AdminLogin";

export default function AdminSetPassword({ mode }) {
  const { token } = useParams();
  const { signIn } = useAdmin();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [pw, setPw] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get(`/admin/auth/token/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(errorText(e))); }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      const { data } = await api.post("/admin/auth/set-password", { token, password: pw.a });
      signIn(data); toast.success("Password saved"); navigate("/admin");
    } catch (err) { toast.error(errorText(err)); } finally { setBusy(false); }
  };

  return (
    <AdminFrame title={mode === "setup" ? "Set your password" : "New password"}>
      {error && <div className="mt-6 text-sm text-[var(--muted)]" data-testid="admin-token-error">{error} <Link to="/admin/login" className="underline text-white">Go to sign in</Link></div>}
      {info && (
        <form onSubmit={submit} className="mt-8 space-y-3" data-testid="admin-set-password-form">
          <p className="text-sm text-[var(--muted)]">For <span className="text-white" data-testid="admin-setup-email">{info.email}</span>. Minimum 8 characters. Only a hash is stored.</p>
          <input className="field" type="password" placeholder="New password" value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} required minLength={8} data-testid="admin-new-password" />
          <input className="field" type="password" placeholder="Repeat password" value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} required minLength={8} data-testid="admin-repeat-password" />
          <button type="submit" disabled={busy} className="btn-accent w-full py-3.5" data-testid="admin-set-password-submit">Save and sign in</button>
        </form>
      )}
    </AdminFrame>
  );
}
